// CSS `zoom` on <html> (see ZoomContext) visually scales the entire UI, but
// `event.clientX/Y`, `getBoundingClientRect()`, and `window.innerWidth/Height`
// all return values already in that scaled viewport coordinate space. Writing
// those scaled values back as CSS `top`/`left` on a portal-mounted overlay
// inside the zoomed root multiplies them by `zoom` again — the overlay then
// drifts off by a factor of `zoom` from the cursor / anchor. Divide
// coordinate-space values by `getActiveZoom()` before assigning them as CSS
// lengths to undo the double-scale.
export function getActiveZoom(): number {
  if (typeof document === 'undefined') return 1;
  const raw = document.documentElement.style.zoom;
  if (!raw) return 1;
  const parsed = parseFloat(raw);
  if (!Number.isFinite(parsed) || parsed <= 0) return 1;
  return parsed;
}
